module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "gwi-login"
    }
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginShow),
      expression: "loginShow"
    }],
    staticClass: "login-form",
    attrs: {
      "action": ""
    },
    on: {
      "submit": _vm.submitLogin
    }
  }, [_c('div', {
    staticClass: "form-line"
  }, [_c('span', {
    staticClass: "form-icon phone"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.mobileNo),
      expression: "param.mobileNo"
    }],
    staticClass: "gwi-ipt",
    attrs: {
      "type": "text",
      "id": "login-phoneno",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.param.mobileNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "mobileNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('verify-code', {
    staticClass: "login-line",
    attrs: {
      "namespace": "login",
      "url": "/app/user/send",
      "myprop": "isAgreed",
      "param": _vm.param
    },
    model: {
      value: (_vm.verifyCode),
      callback: function($$v) {
        _vm.verifyCode = $$v
      },
      expression: "verifyCode"
    }
  }, [_c('span', {
    staticClass: "form-icon pwd"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-line clear-border",
    staticStyle: {
      "height": "40px",
      "line-height": "45px"
    }
  }, [_c('label', {
    staticStyle: {}
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAgreed),
      expression: "isAgreed"
    }],
    staticClass: "cb",
    attrs: {
      "type": "checkbox",
      "name": "name",
      "id": "login-check"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAgreed) ? _vm._i(_vm.isAgreed, null) > -1 : (_vm.isAgreed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isAgreed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAgreed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isAgreed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAgreed = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "icon-cb",
    attrs: {
      "for": "login-check"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "f-strong",
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "login-agreement"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showAgreement()
      }
    }
  }, [_vm._v("同意软件许可及服务协议")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.configShown),
      expression: "configShown"
    }]
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.backendUrl),
      expression: "backendUrl"
    }],
    staticClass: "gwi-ipt",
    attrs: {
      "type": "text",
      "placeholder": "后台地址"
    },
    domProps: {
      "value": (_vm.backendUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.backendUrl = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setUrl
    }
  }, [_vm._v("OK")])]), _vm._v(" "), _c('div', {
    staticClass: "flat-row"
  }, [_c('button', {
    staticClass: "btn-ok",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.isAgreed || !_vm.verifyCode || !_vm.param.mobileNo
    }
  }, [_vm._v("登录")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31c4d606","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/login/Login.vue
// module id = 808
// module chunks = 0